import React, { Fragment } from 'react'
import { translate } from '../Services/translation'
import BEMHelper from 'react-bem-helper'
import { put } from '../Services/http'
import { setCookie } from '../Services/cookieService'

const c = new BEMHelper('language-link')

function LanguageLink({ text, href, attributes }) {
    return (
        <div key={text} {...c('item')}>
            <a
                {...c('link', { active: attributes.active })}
                onClick={async (event) => {
                    setCookie(
                        window.__litium.geoLocationData.cookieName,
                        attributes.alpha2
                    )
                    event.preventDefault()
                    await put(`/api/navigation/setCountry/${attributes.alpha2}`)
                    window.location = href
                }}
                href={href}
            >
                {text}
            </a>
        </div>
    )
}

const LanguageLinks = ({
    links,
    iconCssClass,
    showLanguageLinks,
    toggleShowLanguageLinks,
    currentCountryName,
}) => {
    return (
        <Fragment>
            {links && links.length > 0 && (
                <div {...c('country-container')}>
                    <a
                        {...c('link', 'block')}
                        href="#!"
                        onClick={toggleShowLanguageLinks}
                        title={translate(
                            'languagelinks.languageselect.tooltip'
                        )}
                    >
                        <div {...c('text')}>
                            {translate('languagelinks.countryselect.title')}{' '}
                            <span {...c('text', 'active')}>
                                {currentCountryName}
                            </span>
                        </div>
                        <div {...c('icon', { rotate: showLanguageLinks })}>
                            <i className={iconCssClass} />
                        </div>
                    </a>

                    <div {...c('links', { hidden: !showLanguageLinks })}>
                        {links.map(LanguageLink)}
                    </div>
                </div>
            )}
        </Fragment>
    )
}

export default LanguageLinks
